import React from 'react';
import { useLocation } from '@reach/router';
import { CheckCircle2, Wrench } from 'lucide-react';
import * as styles from './aiEngineerFellowship.module.scss';
import LeadGenerationButton from '@components/LeadGenerationForm/LeadGenerationButton';
import { LEAD_GEN_CAREER_ASSISTANCE } from '@src/constants/LeadGenerationConstants/index';
import useRequestCallback from './useRequestCallback';
import { ICONS } from './iconRegistry';

const WhoItsFor = ({ content }) => {
  const onSubmitPageOne = useRequestCallback();
  const { cards, prereqs, prework } = content;
  const location = useLocation();

  // A PDF (or any external link) can't embed a live form, but a link can
  // carry this param so landing here auto-opens the same Request Callback
  // modal the "Talk to an Advisor" buttons open on click — e.g. the
  // brochure's "Talk to an Advisor" links to /ai-engineering/?talk_to_advisor=1.
  const shouldAutoOpen = new URLSearchParams(location.search).get('talk_to_advisor') === '1';

  return (
    <section id="who" className={styles.mint}>
      <div className={styles.wrap}>
        <div className={styles.shead}>
          <h2>Who This Program Is For</h2>
          <p>Built for software engineers moving into AI. No prior ML or GenAI experience needed.</p>
        </div>
        <div className={styles.cards4}>
          {cards.map((c) => {
            const Icon = ICONS[c.icon];
            return (
              <div className={styles.card} key={c.h}>
                <div className={styles.ci}>{Icon && <Icon size={20} aria-hidden="true" />}</div>
                <div className={styles.k}>{c.k}</div>
                <h4>{c.h}</h4>
                <p>{c.p}</p>
              </div>
            );
          })}
        </div>
        <div className={styles.prereq}>
          <div>
            <h4 style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <CheckCircle2 size={16} aria-hidden="true" /> Pre-requisites
            </h4>
            <ul>
              {prereqs.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
          <div>
            <h4 style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <Wrench size={16} aria-hidden="true" /> Pre-work (~8–10 hrs, self-paced)
            </h4>
            <ul>
              {prework.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <p style={{ fontSize: 13, color: 'var(--muted)', marginTop: 8 }}>
              No prior ML, deep-learning or LLM experience required — the refreshers are built in.
            </p>
          </div>
          <div className={styles.prereqFoot}>
            <p>
              <b>Not sure you&apos;re a fit?</b> Request a callback — a program advisor will tell
              you honestly whether to start now or prep first. No payment, no commitment.
            </p>
            <LeadGenerationButton
              text="Request a Callback"
              isOnePageForm
              shouldOpenLeadForm={shouldAutoOpen}
              formHeading="Request Callback"
              pageOneButtonText="Call me back"
              onSubmitPageOne={onSubmitPageOne}
              buttonLocation={LEAD_GEN_CAREER_ASSISTANCE}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoItsFor;
